import actions from './monitoringActions'
import mutations from './monitoringMutations'

export default {
  namespaced: true,
  actions,
  mutations
}